import Vue from 'vue'
import Vuetify from 'vuetify'
import i18n from './i18n.js'

import ru from 'vuetify/es5/locale/ru'
import en from 'vuetify/es5/locale/en'
import colors from 'vuetify/lib/util/colors'
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const theme = {
  options: { customProperties: true },
  themes: {
    light: {
      primary: colors.blue.darken2,
      secondary: colors.grey.darken1,
      accent: colors.blue.darken3,
      error: colors.red.accent2,
      info: colors.blue.darken1,
      success: colors.green.base,
      warning: colors.orange.darken2,
      anchor: colors.blue.base,
      loader: colors.blue.lighten3,
      primaryiconbtn: colors.orange.darken3,
      secondaryiconbtn: colors.shades.white,
      addbtn: colors.green.base,
      requiredfield: colors.red.base,
      textcolor: colors.grey.darken4,
      inactiveitem: colors.grey.darken1,
      textwithbackground: colors.shades.white
    },
    dark: {
      primary: colors.blue.base,
      secondary: colors.grey.darken1,
      accent: colors.blue.darken3,
      error: colors.red.accent2,
      info: colors.blue.darken1,
      success: colors.green.base,
      warning: colors.orange.darken2,
      anchor: colors.blue.base,
      loader: colors.blue.lighten3,
      primaryiconbtn: colors.orange.darken3,
      secondaryiconbtn: colors.shades.white,
      addbtn: colors.green.base,
      requiredfield: colors.red.base,
      textcolor: colors.shades.white,
      inactiveitem: colors.grey.lighten1,
      textwithbackground: colors.shades.white
    }
  }
}

const opts = {
  lang: {
    locales: i18n.locale === 'ru' ? { ru } : { en },
    current: i18n.locale
  },
  icons: {
    iconfont: 'mdi' // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
  theme
}

export default new Vuetify(opts)
